import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { FlatList, Platform, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import dayjs from 'dayjs'
import IconButton from '../../../../../components/IconButton';
import Header from '../../../../../navigation/Header';
import ImageViewer from './ImageViewer';
import { ImageZoom } from '@likashefqet/react-native-image-zoom';
import BottomSheet from '@gorhom/bottom-sheet';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';
import { PaymentMethodSelector } from '../Fees/AddPaymentModal';
import Select from '../../../../../components/Forms/Select';
import DateSelector from '../../../../../components/Forms/DateSelector';
import { Ionicons } from '@expo/vector-icons';
import useFormSubmit from '../../../../../hooks/useFormSubmit';


export function PendingFeeUnitSelector({ control, name, communityId, unitId }) {
  const { isLoading, data: unitFees } = useQuery({
    queryKey: ['unit.pending-fees', communityId, unitId],
    queryFn: () => api.get(`/communities/${communityId}/units/${unitId}/fees?pending=1`).then(response => response.data),
    enabled: !!unitId,
  })


  const options = useMemo(() => {
    const defaultValue = { value: "", label: "Sin definir" }

    const options = unitFees?.map(unit_fee => {
      return { value: unit_fee.uuid, label: `${unit_fee.fee.name} ($${unit_fee.amount})` }
    })

    return options ? [...options] : []
  }, [unitFees])


  return (
    <Select
      control={control}
      name={name}
      placeholder={{ value: "", label: "Sin definir" }}
      items={options}
      rules={{}}
      style={{ wrapper: `mb-0 w-60`, input: tw`bg-gray-100 pr-4` }}
    />
  )
}



// Por debajo de este ancho de columna, imagen y formulario no caben lado a lado.
const NARROW_LAYOUT_WIDTH = 640;

export default function EvidenceValidatorScreen({ route, navigation }) {
  const { communityId, payment_evidence_id } = route.params

  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [selectedEvidence, setSelectedEvidence] = useState();
  const [selectedEvidenceIndex, setSelectedEvidenceIndex] = useState<number|null>();
  const [isNarrow, setIsNarrow] = useState(false);
  const { control, handleSubmit, watch, setValue, reset } = useForm();

  const { isInitialLoading, error, data: paymentEvidences, refetch } = useQuery({
    queryKey: ['community.payments.evidences', communityId],
    queryFn: () => api.get(`/communities/${communityId}/payments/evidences`).then(response => response.data),
  })

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: () => {
      refetch()
    },
    onError: (error) => {
      if (error?.message) {
        setErrorMessage(error?.message)
      }
    },
    successToastMessage: "Comprobante validado",
    endpoint: `/communities/${communityId}/payments/evidences/${selectedEvidence?.uuid}/approve`,
  })


  const hasOwners = (selectedEvidence?.unit?.owners?.length ?? 0) > 0

  // bottomsheet
  const bottomSheetRef = useRef<BottomSheet>(null);
  const snapPoints = useMemo(() => [hasOwners ? 110 : 86, 425], [hasOwners]);
  const handleSheetChanges = useCallback((index: number) => {
    console.log('handleSheetChanges', index);
  }, []);

  // const imageUri = 'https://images.unsplash.com/photo-1708516514746-9979b248d4bb?q=80&w=2807&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
  // const imageUri = 'https://www.quadratin.com.mx/www/wp-content/uploads/2023/02/0D22A2BE-1FFC-4AD0-AC7F-5EFC901080EF-473x1024.jpeg'


  const goToPrevEvidence = () => {
    if(selectedEvidenceIndex == undefined) return
    if((selectedEvidenceIndex - 1) >= 0){
      setSelectedEvidenceIndex(selectedEvidenceIndex - 1)
      setCurrentEvidence(paymentEvidences[selectedEvidenceIndex - 1])
    }
  }

  const goToNextEvidence = () => {
    if (selectedEvidenceIndex == undefined) return

    if(paymentEvidences.length > (selectedEvidenceIndex + 1)){
      setSelectedEvidenceIndex(selectedEvidenceIndex + 1)
      setCurrentEvidence(paymentEvidences[selectedEvidenceIndex + 1])
    }
  }

  const setCurrentEvidence = (paymentEvidence) => {
    if (!paymentEvidence) return
    setSelectedEvidence(paymentEvidence)
    // Las flechas anterior/siguiente actualizan el param para que la lista de la columna
    // de al lado marque el comprobante que se está viendo.
    if (paymentEvidence.uuid !== payment_evidence_id) navigation.setParams({ payment_evidence_id: paymentEvidence.uuid })
    setValue('amount', `${paymentEvidence.amount}`)
    setValue('fee_unit_id', paymentEvidence.fee_units?.[0]?.uuid ?? '')//! TODO: adaptar para varios!!
    setValue('apply_date', new Date(paymentEvidence.created_at))
  }


  useEffect(() => {
    if (paymentEvidences){
      if (paymentEvidences.length == 0){
        navigation.goBack()
        return
      }
      const evidenceIndex = paymentEvidences?.findIndex(e => e.uuid == payment_evidence_id)
      const evidence = paymentEvidences[evidenceIndex]
      setSelectedEvidenceIndex(evidenceIndex)
      setCurrentEvidence(evidence)
    }
    // payment_evidence_id: en web el validador se queda montado en la tercera columna y
    // elegir otro comprobante de la lista solo le cambia el param.
  }, [paymentEvidences, payment_evidence_id]);
  




  function _submitForm(data){
    const _data = {
      ...data,
      fee_unit_ids: [data.fee_unit_id],
    }
    delete _data.fee_unit_id

    console.log(_data, selectedEvidence.uuid)

    submitForm(_data)
  }

  function rejectPayment(){
    // 
  }


  return (
    <View style={tw`flex-1`}>
      <Header
        showBackButton
        style={tw.style(`bg-secondary pb-4 rounded-b-0`)}
        backButtonColor='white'
      >
        {/* La lista de al lado ya dice "Comprobantes de pago". */}
        <Text style={tw`text-lg font-600 text-white`}>Revisar comprobante</Text>
      </Header>

      {/* Se mide el ancho de la columna (no de la ventana): angosta → imagen arriba y campos abajo. */}
      <View
        style={tw.style(`flex flex-1`, isNarrow ? `flex-col` : `flex-row`)}
        onLayout={(e) => setIsNarrow(e.nativeEvent.layout.width < NARROW_LAYOUT_WIDTH)}
      >
        <View style={tw.style(`bg-black`, isNarrow ? `h-80` : `flex-1`)}>
          <ImageViewerWeb source={selectedEvidence?.images?.[0]?.url} />
          

          <TouchableOpacity
            style={tw`bg-white rounded-full h-12 w-12 absolute top-10 left-3 justify-center items-center`}
            onPress={goToPrevEvidence}
          >
            <Ionicons name='chevron-back' size={20} />
          </TouchableOpacity>

          <TouchableOpacity
            style={tw`bg-white rounded-full h-12 w-12 absolute top-10 right-3 justify-center items-center`}
            onPress={goToNextEvidence}
          >
            <Ionicons name='chevron-forward' size={20} />
          </TouchableOpacity>
        </View>

        <ScrollView style={tw`flex-1 bg-white`} contentContainerStyle={tw`flex-grow`}>
          <BottomValidator
            selectedEvidence={selectedEvidence}
            hasOwners={hasOwners}
            control={control}
            communityId={communityId}
            isSubmitting={isSubmitting}
            errorMessage={errorMessage}
            onApprovedPressed={handleSubmit(_submitForm)}
            onRejectPressed={rejectPayment}
          />
        </ScrollView>
      </View>
    </View>
  )
}


function BottomValidator({ 
  selectedEvidence, hasOwners, control, communityId, isSubmitting,
  onApprovedPressed, onRejectPressed, errorMessage,
}){
  return (
    <View style={tw`flex-1 px-6 pt-4 bg-white`}>
      {
        selectedEvidence &&
        <>
          <View style={tw`flex-1`}>
            <View style={tw`mb-4`}>
              <Text style={tw`text-xl`}>{selectedEvidence.id} - {selectedEvidence.unit?.name}</Text>

              {/* {
                hasOwners &&
                <Text style={tw`text-gray-400`}>{selectedEvidence.unit?.owners[0].name}</Text>
              } */}
              {
                selectedEvidence.fee_units?.map(fee_unit => 
                  <Text>{fee_unit.fee.name}</Text>  
                )
              }
            </View>

            {/* Monto */}
            <View style={tw`mb-4 row justify-between`}>
              <Text>Monto</Text>

              {/* Signo de pesos dentro del campo; el texto se recorre para no encimarse. */}
              <View style={tw`relative`}>
                <Input
                  control={control}
                  name='amount'
                  placeholder=''
                  style={{ container: tw`mb-0`, subcontainer: `w-40`, input: `w-40 pl-9` }}
                  rules={{ required: true }}
                  keyboardType="numeric"
                />
                <View pointerEvents="none" style={tw`absolute left-5 top-0 h-12 justify-center`}>
                  <Text style={tw`font-bold text-gray-500`}>$</Text>
                </View>
              </View>
            </View>

            {/* Forma de pago */}
            <View style={tw`mb-4 row justify-between`}>
              <Text style={tw`text-gray-500`}>Forma de Pago</Text>

              <View style={tw`w-40`}>
                <PaymentMethodSelector control={control} name={"payment_method_id"} communityId={communityId} />
              </View>
            </View>

            {/* Fecha contable */}
            <View style={tw`mb-4 row justify-between`}>
              <Text style={tw`text-gray-500`}>Fecha contable</Text>

              <DateSelector
                control={control}
                name="apply_date"
                style={tw`w-40 mb-0`}
                rules={{}}
                dateFormat="D/MM/YYYY"
              />
            </View>


            {/* Cuota */}
            <View style={tw`mb-4 row justify-between`}>
              <Text style={tw`text-gray-500`}>Cuota</Text>

              <PendingFeeUnitSelector
                control={control}
                name={'fee_unit_id'}
                communityId={communityId}
                unitId={selectedEvidence.unit?.uuid}
              />
            </View>

            {/* Folio */}
            <View style={tw`mb-4 row justify-between`}>
              <Text>Folio</Text>

              <Input
                control={control}
                name='folio'
                placeholder=''
                style={{ container: tw`mb-0`, subcontainer: `w-40`, input: `w-40` }}
              />
            </View>
          </View>


          {
            errorMessage &&
            <Text style={tw`text-red text-center pb-6`}>{errorMessage}</Text>
          }


          {/* Botones inferiores */}
          {/* Apilados y a ancho completo, igual que en la app. */}
          <View style={tw`pb-6`}>
            <IconButton
              title={isSubmitting ? "Procesando..." : "Aprobar"}
              icon={null}
              disabled={isSubmitting}
              style={tw.style(`py-3 mb-3`, (isSubmitting) && `bg-gray-700`)}
              onPress={onApprovedPressed}
            />

            <IconButton
              title={isSubmitting ? "Procesando..." : "Rechazar"}
              icon={null}
              disabled={isSubmitting}
              color='red-400'
              style={tw.style(`py-3`, (isSubmitting) && `bg-gray-700`)}
              onPress={onRejectPressed}
            />
          </View>
        </>
      }
    </View>
  )
}


// Click en la imagen (o en el botón) la abre completa en otra pestaña, como las imágenes
// de los tickets. contain: el comprobante se ve entero, sin recortes.
function ImageViewerWeb({source}){
  const openImage = () => {
    if (source) window.open(source, '_blank', 'noopener,noreferrer')
  }

  return (
    <View style={tw`flex-1`}>
      <TouchableOpacity activeOpacity={0.9} onPress={openImage} style={tw`flex-1`} disabled={!source}>
        <Image source={source} style={tw`w-full h-full`} contentFit="contain" />
      </TouchableOpacity>

      {!!source && (
        <TouchableOpacity
          style={tw`bg-white rounded-full h-12 w-12 absolute top-24 right-3 justify-center items-center`}
          onPress={openImage}
          accessibilityLabel="Abrir imagen en otra ventana"
        >
          <Ionicons name='expand-outline' size={20} />
        </TouchableOpacity>
      )}
    </View>
  )
}